<template>
  <div class="page-container">
    <div class="linha">
      <machine v-if="maquinasAtuais.length > 0" :maquina="maquinasAtuais[0]" field="oee"></machine>
      <machine v-if="maquinasAtuais.length > 1" :maquina="maquinasAtuais[1]" field="oee"></machine>
    </div>
    <div class="linha">
      <machine v-if="maquinasAtuais.length > 2" :maquina="maquinasAtuais[2]" field="oee"></machine>
      <machine v-if="maquinasAtuais.length > 3" :maquina="maquinasAtuais[3]" field="oee"></machine>
    </div>
  </div>
</template>

<script>
import Machine from "../components/Machines/Machine4";
import api from "../services/api.js";
import fakeData from "../store/fakeData.js";

export default {
  name: "OEE4",
  components: {
    Machine
  },
  data: () => ({
    maquinaAtual: {
      seqMaquina: 0,
      ordem: "",
      peca: "",
      codigo: "",
      oee: 0,
      desempenho: 0,
      disponibilidade: 0,
      qualidade: 0,
      progress: 0,
      total: 0,
      status: "Indef.",
      faltante: 0,
      atraso: 0,
      tempoEstado: "00:00",
      hitoricoOEE: [],
      dateAtual: "00:00",
      indice: -1
    },
    maquinasAtuais: [],
    maquinas: [],
    seqsMaquina: [],
    seqFormatado: [],
    seqsMaquinaAtuais: []
  }),
  async created() {
    if (this.$store.state.fake) {
      this.maquinasAtuais = fakeData;
      this.maquinaAtual = fakeData[3];
    } else {
      this.seqsMaquina = this.$store.state.modeloAtual.PRD057_ASSOC_MODELO_PAR_MAQ.map(
        maquina => maquina.SEQ_PARTE_MAQUINA
      );
      this.seqFormatado = this.seqsMaquina.join(",");
      let res = await api().get(`ObterDadosPartesMaquina/${this.seqFormatado}`);
      this.maquinas = res.data;

      let i;
      for (i = 0; i < 4 && i < this.maquinas.length; i++) {
        this.setMaquina(this.maquinas[i]);
      }
      this.setHoraAtual(this.maquinaAtual.dateAtual);
      this.rodarMaquinas();
      this.rodarRefresh();
    }
  },
  methods: {
    rodarMaquinas() {
      const intervalo = setInterval(() => {
        let indiceAtual = this.maquinaAtual.indice;
        const nMaquinas = this.maquinas.length;
        this.maquinasAtuais = [];
        let i;
        for (i = 0; i < 4 && i < this.maquinas.length; i++) {
          this.setMaquina(this.maquinas[(indiceAtual + 1) % nMaquinas]);
          indiceAtual = this.maquinaAtual.indice;
        }
        this.setHoraAtual(this.maquinaAtual.dateAtual);
      }, this.$store.state.timer * 1000);
      this.$on("hook:beforeDestroy", () => {
        clearInterval(intervalo);
      });
    },
    setMaquina(maquina) {
      let indiceAtual = this.maquinaAtual.indice;
      let nMaquinas = this.maquinas.length;
      this.maquinaAtual = {
        seqMaquina: maquina.SEQ_PARTE_MAQUINA,
        ordem: maquina.NUM_OS,
        peca: maquina.COD_PRODUTO,
        codigo: maquina.COD_PARTE_MAQUINA,
        oee: maquina.VLR_OEE,
        desempenho: maquina.VLR_DESEMPENHO,
        disponibilidade: maquina.VLR_DISPONIBILIDADE,
        descricao: maquina.DSC_PARTE_MAQUINA,
        qualidade: maquina.VLR_QUALIDADE,
        progress: maquina.VLR_TOTAL_PRODUZIDO,
        total: maquina.VLR_QUANTIDADE_TOTAL,
        status: maquina.DSC_TIPO,
        faltante: maquina.VLR_QUANTIDADE_FALTANTE,
        atraso: maquina.VLR_QUANTIDADE_ATRASO,
        tempoEstado: maquina.STR_VLR_TEMPO_ESTADO,
        hitoricoOEE: maquina.VLR_HISTORICO_OEE,
        dateAtual: maquina.STR_HORA_ATUAL,
        indice: (indiceAtual + 1) % nMaquinas
      };
      this.maquinasAtuais.push(this.maquinaAtual);
    },
    rodarRefresh() {
      const intervalo = setInterval(() => {
        this.seqsMaquinaAtuais = [];
        for (let i = 0; i < this.maquinasAtuais.length; i++) {
          this.seqsMaquinaAtuais.push(this.maquinasAtuais[i].seqMaquina);
        }
        this.setMaquinaRefresh(this.seqsMaquina.length);
        this.setHoraAtual(this.maquinaAtual.dateAtual);
      }, 5000);
      this.$on("hook:beforeDestroy", () => {
        clearInterval(intervalo);
      });
    },
    async setMaquinaRefresh(count) {
      let res = await api().get(`ObterDadosPartesMaquina/${this.seqFormatado}`);
      this.maquinas = res.data;
      let indiceAtual = this.maquinaAtual.indice;

      this.maquinasAtuais = [];
      for (let i = 0; i < count; i++) {
        this.maquinaAtual = {
          seqMaquina: this.maquinas[i].SEQ_PARTE_MAQUINA,
          ordem: this.maquinas[i].NUM_OS,
          peca: this.maquinas[i].COD_PRODUTO,
          codigo: this.maquinas[i].COD_PARTE_MAQUINA,
          oee: this.maquinas[i].VLR_OEE,
          desempenho: this.maquinas[i].VLR_DESEMPENHO,
          disponibilidade: this.maquinas[i].VLR_DISPONIBILIDADE,
          qualidade: this.maquinas[i].VLR_QUALIDADE,
          descricao: this.maquinas[i].DSC_PARTE_MAQUINA,
          progress: this.maquinas[i].VLR_TOTAL_PRODUZIDO,
          total: this.maquinas[i].VLR_QUANTIDADE_TOTAL,
          status: this.maquinas[i].DSC_TIPO,
          faltante: this.maquinas[i].VLR_QUANTIDADE_FALTANTE,
          atraso: this.maquinas[i].VLR_QUANTIDADE_ATRASO,
          tempoEstado: this.maquinas[i].STR_VLR_TEMPO_ESTADO,
          hitoricoOEE: this.maquinas[i].VLR_HISTORICO_OEE,
          dateAtual: this.maquinas[i].STR_HORA_ATUAL,
          indice: indiceAtual
        };

        if (this.seqsMaquinaAtuais.indexOf(this.maquinaAtual.seqMaquina) > -1) {
          this.maquinasAtuais.push(this.maquinaAtual);
        }
      }
    },
    setHoraAtual(date) {
      this.$store.commit("gravarDate", { date });
    }
  }
};
</script>

<style scoped>
.page-container {
  padding: 1rem;
  height: calc(100% - 7rem);
}

.linha:last-child {
  margin-top: 1rem;
}

.linha {
  height: calc(50% - 0.5rem);
  width: 100%;
  display: flex;
}
.linha:first-child {
  margin-right: 0.8rem;
}

.linha > :last-child:not(:only-child) {
  margin-left: 1rem;
}
</style>
